exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slotRequestStatus[data-v-227acbc9] .v-select__selection{text-transform:none;color:rgba(0,0,0,.87);font-weight:300;font-size:1rem;max-width:100%;margin:0}", ""]);

// exports
